import { installGlobalErrorHandlers } from '@/lib/logger/global-handlers';
import { initLoggerContext } from '@/lib/logger/init-logger-context';
import { TrackingProvider } from '@/lib/tracking';
import { ToastProvider } from '@components/ui/Toast';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { appConfig } from './config/app.config.ts';

import './index.css';
// Warning: Don't remove this import. It is required to initialize the i18n library.
import './lib/i18n/i18n.config';

initLoggerContext();
installGlobalErrorHandlers();

if (appConfig.useMswMocks) {
  const { worker } = await import('./mocks/browser');
  await worker.start();
} else if (appConfig.useTemporaryEndpointsMock) {
  // TODO(HUM-25935): temporary — remove when the backend serves /metrics and /get-started again.
  const { temporaryMockWorker } = await import('./mocks/temporary-mock-worker');
  await temporaryMockWorker.start({ onUnhandledRequest: 'bypass' });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <TrackingProvider>
      <App />
      <ToastProvider />
    </TrackingProvider>
  </StrictMode>
);
